export default __webpack_public_path__ + "static/media/dashboard-patient-icon.46e44cc6.svg";